import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoMissingTitleComponent } from './options/missing-title/missing-title.component';
import { SeoDuplicateTitleComponent } from './options/duplicate-title/duplicate-title.component';
import { SeoMissingH1Component } from './options/missing-h1/missing-h1.component';
import { SeoDuplicateH1Component } from './options/duplicate-h1/duplicate-h1.component';
import { SeoMissingAltComponent } from './options/missing-alt/missing-alt.component';
import { SeoMultipleH1Component } from './options/multiple-h1/multiple-h1.component';
import { SeoMissingSubheadlinesComponent } from './options/missing-subheadlines/missing-subheadlines.component';
import { SeoMissingMetaDescriptionComponent } from './options/missing-meta-description/missing-meta-description.component';
import { SeoTooLongMetaDescriptionComponent } from './options/too-long-meta-description/too-long-meta-description.component';
import { SeoTooLongUrlComponent } from './options/too-long-url/too-long-url.component';
import { SeoTooManyPageLinksComponent } from './options/too-many-page-links/too-many-page-links.component';
import { SeoTooShortMetaDescriptionComponent } from './options/too-short-meta-description/too-short-meta-description.component';
import { SeoNoFollowComponent } from './options/no-follow/no-follow.component';
import { SeoNoIndexComponent } from './options/no-index/no-index.component';

@Component({
    selector: 'quick-help-translations',
    templateUrl: './translations.component.html',
    standalone: true,
    imports: [
        CommonModule,
        SeoMissingTitleComponent,
        SeoDuplicateTitleComponent,
        SeoMissingH1Component,
        SeoDuplicateH1Component,
        SeoMissingAltComponent,
        SeoMultipleH1Component,
        SeoMissingSubheadlinesComponent,
        SeoMissingMetaDescriptionComponent,
        SeoTooLongMetaDescriptionComponent,
        SeoTooLongUrlComponent,
        SeoTooManyPageLinksComponent,
        SeoTooShortMetaDescriptionComponent,
        SeoNoFollowComponent,
        SeoNoIndexComponent,
    ],
})
export class QuickHelpTranslationsComponent {
    @Input() seoName: string = '';
}
